import React, {useEffect, useState} from "react";
import ValueInputField from "../Elements/ValueInputField";
import InputTypeHidden from "../Elements/InputTypeHidden";
import PlzInputField from "../Elements/PlzInputField";

const ErdgasGewerbe = (props) => {
    const [plz, setPlz] = useState();
    const threshold = 499999;

    useEffect(() => {
        props.setThreshold(threshold);
        props.setDisableButton(true);
    }, [])

    return <div className="gas-gewerbe">
        <div className="row">
            <div className="col-md-6 col-lg-12">
                <p><strong>Finden Sie hier Ihr passendes Erdgas-Produkt:</strong></p>

                <div className="row row-small-gutters">
                    <div className="col-sm-6">
                        <PlzInputField setDisableButton={props.setDisableButton} setErrorText={props.setErrorText} type="GAS" setShowError={props.setShowError} setValue={setPlz} name="postalCode" placeholder="Ihre PLZ"/>
                    </div>
                    <div className="col-sm-6">
                        <ValueInputField name="consumption" setValue={props.setCurrentValue} placeholder="Jahresverbrauch (kWh)"/>
                    </div>
                    <InputTypeHidden name="customerType" value="BUSINESS"/>
                    <InputTypeHidden name="mediaType" value="GAS"/>
                </div>
            </div>
        </div>
    </div>
}

export default ErdgasGewerbe;